export const UI = {
  en: {
    // Navbar
    navHome: 'Home', navAbout: 'About', navServices: 'Services',
    navPortfolio: 'Portfolio', navReviews: 'Reviews', navContact: 'Contact',
    navBook: 'Book Consultation',
    // Hero buttons
    btnBook: 'Book a Consultation →',
    btnServices: 'See Our Services',
    btnProfile: 'Our Profile →',
    heroScroll: 'Scroll',
    whyAmko: 'Why AMKO?',
    // About
    aboutTag: 'Who We Are',
    aboutHeading: 'About AMKO Agency',
    aboutSub: 'A creative marketing, branding, and event management agency based in Erbil.',
    aboutVision: 'Vision —',
    aboutMission: 'Mission —',
    ourValues: 'Our Values',
    // Services
    servicesTag: 'What We Do',
    servicesHeading: 'Our Services',
    servicesSub: 'Everything your brand needs — under one roof.',
    // Process
    processTag: 'Our Process',
    processHeading: 'How We Work',
    // Portfolio
    portfolioTag: 'Our Work',
    portfolioHeading: 'Portfolio',
    portfolioSub: "A selection of projects we're proud of.",
    portfolioEmpty: 'Portfolio items will appear here.',
    portfolioEmptySub: 'Managed from the admin panel.',
    // Clients
    clientsTag: 'Our Clients',
    clientsHeading: 'Trusted By',
    // Reviews
    reviewsTag: 'Client Feedback',
    reviewsHeading: 'What Clients Say',
    reviewsCount: 'Based on 48 reviews',
    // Leave a review
    leaveReview: 'Leave a Review',
    leaveReviewSub: 'Reviews are approved before publishing.',
    reviewThanks: 'Thank You!',
    reviewThanksMsg: 'Your review has been submitted for approval.',
    reviewNamePh: 'Your Name *',
    reviewRolePh: 'Role / Company',
    reviewRatingLabel: 'Rating *',
    reviewTextPh: 'Share your experience... *',
    reviewSubmit: 'Submit Review',
    // FAQ
    faqTag: 'FAQ',
    faqHeading: 'Frequently Asked Questions',
    // Contact
    contactTag: 'Get In Touch',
    contactHeading: 'Contact Us',
    contactSub: "Ready to start? Let's talk.",
    contactPhone: 'Phone / WhatsApp',
    contactEmail: 'Email',
    contactLocation: 'Location',
    // Consultation form
    cfFirstName: 'First Name *',
    cfLastName: 'Last Name *',
    cfEmail: 'Email Address *',
    cfPhone: 'Phone Number *',
    cfService: 'Select a service...',
    cfMessage: 'Your message *',
    cfSend: 'Send Request →',
    cfSending: 'Sending…',
    cfSuccess: 'Request Sent!',
    cfSuccessMsg: "We've received your consultation request and will get back to you within 24 hours.",
    cfSendAnother: 'Send Another',
    cfNote: '✉ Your request will be sent to our team at sales@amkoiq.com',
    // Book modal
    bookHeading: 'Book a Consultation',
    bookSub: "Fill in the form and we'll confirm within 24 hours.",
    bookReceived: 'Reservation Received!',
    bookConfirm: 'We will confirm within 24 hours.',
    bookClose: 'Close',
    bookFullName: 'Full Name *',
    bookEmail: 'Email *',
    bookPhone: 'Phone *',
    bookSelectService: 'Select a service...',
    bookDate: 'Preferred Date *',
    bookTime: 'Preferred Time *',
    bookNotes: 'Notes (optional)',
    bookSubmit: 'Submit Reservation →',
    // PDF modal
    pdfTitle: 'AMKO Agency — Company Profile',
  },

  ar: {
    // Navbar
    navHome: 'الرئيسية', navAbout: 'عنّا', navServices: 'خدماتنا',
    navPortfolio: 'أعمالنا', navReviews: 'التقييمات', navContact: 'تواصل وياهنا',
    navBook: 'احجز استشارة',
    // Hero buttons
    btnBook: '← احجز استشارة',
    btnServices: 'شوف خدماتنا',
    btnProfile: '← بروفايلنا',
    heroScroll: 'اسحب',
    whyAmko: 'ليش AMKO؟',
    // About
    aboutTag: 'منو إحنا',
    aboutHeading: 'عن وكالة AMKO',
    aboutSub: 'وكالة إبداعية متخصصة بالتسويق والبراندينغ وإدارة الفعاليات — من أربيل.',
    aboutVision: 'رؤيتنا —',
    aboutMission: 'رسالتنا —',
    ourValues: 'قيمنا',
    // Services
    servicesTag: 'شو نسوي',
    servicesHeading: 'خدماتنا',
    servicesSub: 'كل ما يحتاجه براندك — تحت سقف واحد.',
    // Process
    processTag: 'طريقة شغلنا',
    processHeading: 'كيف نشتغل',
    // Portfolio
    portfolioTag: 'أعمالنا',
    portfolioHeading: 'محفظة الأعمال',
    portfolioSub: 'مجموعة مختارة من المشاريع اللي نفتخر فيها.',
    portfolioEmpty: 'أعمال المحفظة ستظهر هنا.',
    portfolioEmptySub: 'تُدار من لوحة التحكم.',
    // Clients
    clientsTag: 'عملاؤنا',
    clientsHeading: 'يثقون فينا',
    // Reviews
    reviewsTag: 'تقييمات العملاء',
    reviewsHeading: 'شو يقولون عنا',
    reviewsCount: 'مبني على 48 تقييم',
    // Leave a review
    leaveReview: 'اترك تقييماً',
    leaveReviewSub: 'التقييمات تُراجع قبل النشر.',
    reviewThanks: 'شكراً!',
    reviewThanksMsg: 'تقييمك وصل وراح يُنشر بعد المراجعة.',
    reviewNamePh: 'اسمك *',
    reviewRolePh: 'الوظيفة / الشركة',
    reviewRatingLabel: 'التقييم *',
    reviewTextPh: 'شاركنا تجربتك... *',
    reviewSubmit: 'أرسل التقييم',
    // FAQ
    faqTag: 'أسئلة شائعة',
    faqHeading: 'الأسئلة الأكثر تكراراً',
    // Contact
    contactTag: 'تواصل وياهنا',
    contactHeading: 'اتصل بنا',
    contactSub: 'جاهز تبدأ؟ خلينا نتكلم.',
    contactPhone: 'تلفون / واتساب',
    contactEmail: 'إيميل',
    contactLocation: 'الموقع',
    // Consultation form
    cfFirstName: 'الاسم الأول *',
    cfLastName: 'اسم العائلة *',
    cfEmail: 'البريد الإلكتروني *',
    cfPhone: 'رقم الهاتف *',
    cfService: 'اختار الخدمة...',
    cfMessage: 'رسالتك *',
    cfSend: '← أرسل الطلب',
    cfSending: 'جاري الإرسال…',
    cfSuccess: 'وصل الطلب!',
    cfSuccessMsg: 'استلمنا طلبك وراح نرد عليك خلال 24 ساعة.',
    cfSendAnother: 'أرسل طلب ثاني',
    cfNote: '✉ طلبك راح يوصل لفريقنا على sales@amkoiq.com',
    // Book modal
    bookHeading: 'احجز استشارة',
    bookSub: 'عبي النموذج وراح نأكد خلال 24 ساعة.',
    bookReceived: 'وصلنا الحجز!',
    bookConfirm: 'راح نأكد خلال 24 ساعة.',
    bookClose: 'إغلاق',
    bookFullName: 'الاسم الكامل *',
    bookEmail: 'الإيميل *',
    bookPhone: 'الهاتف *',
    bookSelectService: 'اختار الخدمة...',
    bookDate: 'التاريخ المفضل *',
    bookTime: 'الوقت المفضل *',
    bookNotes: 'ملاحظات (اختياري)',
    bookSubmit: '← أرسل الحجز',
    // PDF modal
    pdfTitle: 'وكالة AMKO — البروفايل',
  },

  ku: {
    // Navbar
    navHome: 'سەرەکی', navAbout: 'دەربارەی', navServices: 'خزمەتگوزاریەکان',
    navPortfolio: 'کارەکانمان', navReviews: 'نظەرەکان', navContact: 'پەیوەندی',
    navBook: 'شوێنپێچوون',
    // Hero buttons
    btnBook: '← شوێنپێچوون',
    btnServices: 'خزمەتگوزاریەکانمان',
    btnProfile: '← پرۆفایلمان',
    heroScroll: 'بڵێزە',
    whyAmko: 'بۆچی AMKO؟',
    // About
    aboutTag: 'ئێمە کێین',
    aboutHeading: 'دەربارەی ئەژانسی AMKO',
    aboutSub: 'ئەژانسی داهێنانی مارکیتنگ، براندینگ و بەڕێوەبردنی ئایین لە هەولێر.',
    aboutVision: 'دیدگا —',
    aboutMission: 'ئەرك —',
    ourValues: 'بەهاکانمان',
    // Services
    servicesTag: 'چی دەکەین',
    servicesHeading: 'خزمەتگوزاریەکانمان',
    servicesSub: 'هەموو ئەوەی براندەکەت پێویستیی پێیە — لە خانەیەكدا.',
    // Process
    processTag: 'ڕێگەی کارمان',
    processHeading: 'چۆن کار دەکەین',
    // Portfolio
    portfolioTag: 'کارەکانمان',
    portfolioHeading: 'پۆرتفۆلیۆ',
    portfolioSub: 'هەڵبژاردەیەك لە پرۆژەکانی سەربەرزیمان.',
    portfolioEmpty: 'کارەکانی پۆرتفۆلیۆ ئێرە دەردەکەون.',
    portfolioEmptySub: 'لە پەنەڵی کۆنترۆڵ بەڕێوە دەبرێت.',
    // Clients
    clientsTag: 'کڕیارەکانمان',
    clientsHeading: 'پشتیان دەبەستین بە',
    // Reviews
    reviewsTag: 'هەڵسەنگاندنەکان',
    reviewsHeading: 'کڕیارەکان چی دەڵێن',
    reviewsCount: 'لەسەر بنەمای ٤٨ هەڵسەنگاندن',
    // Leave a review
    leaveReview: 'هەڵسەنگاندن بنووسە',
    leaveReviewSub: 'هەڵسەنگاندنەکان پێش بڵاوبوونەوە پشکنین دەکرێن.',
    reviewThanks: 'سوپاس!',
    reviewThanksMsg: 'هەڵسەنگاندنەکەت گەیشت و دوای پشکنین بڵاو دەبێتەوە.',
    reviewNamePh: 'ناوت *',
    reviewRolePh: 'پلە / کۆمپانیا',
    reviewRatingLabel: 'هەڵسەنگاندن *',
    reviewTextPh: 'ئەزموونەکەت هاوبەش بکە... *',
    reviewSubmit: 'ناردنی هەڵسەنگاندن',
    // FAQ
    faqTag: 'پرسیارە باوەکان',
    faqHeading: 'پرسیارە دووبارەبووەکان',
    // Contact
    contactTag: 'پەیوەندیمان پێوە بکە',
    contactHeading: 'پەیوەندی',
    contactSub: 'ئامادەی دەستپێکردنی؟ با قسە بکەین.',
    contactPhone: 'تەلەفۆن / واتساپ',
    contactEmail: 'ئیمەیل',
    contactLocation: 'شوێن',
    // Consultation form
    cfFirstName: 'ناوی یەکەم *',
    cfLastName: 'ناوی خێزان *',
    cfEmail: 'ئادرەسی ئیمەیل *',
    cfPhone: 'ژمارەی تەلەفۆن *',
    cfService: 'خزمەتگوزاریەک هەڵبژێرە...',
    cfMessage: 'نامەکەت *',
    cfSend: '← ناردنی داواکاری',
    cfSending: 'دەنێردرێت…',
    cfSuccess: 'داواکاری نێردرا!',
    cfSuccessMsg: 'داواکاریت وەرگرتین و لە ماوەی ٢٤ کاتژمێردا وەڵامت دەدەینەوە.',
    cfSendAnother: 'داواکارییەکی تر بنێرە',
    cfNote: '✉ داواکاریت بۆ تیمەکەمان دەنێردرێت بۆ sales@amkoiq.com',
    // Book modal
    bookHeading: 'شوێنپێچوون',
    bookSub: 'فۆرمەکە پڕ بکەوە، لە ماوەی ٢٤ کاتژمێردا پشتدەڵنیا دەبین.',
    bookReceived: 'شوێنپێچوون وەرگیرا!',
    bookConfirm: 'لە ماوەی ٢٤ کاتژمێردا پشتدەڵنیا دەبین.',
    bookClose: 'داخستن',
    bookFullName: 'ناوی تەواو *',
    bookEmail: 'ئیمەیل *',
    bookPhone: 'تەلەفۆن *',
    bookSelectService: 'خزمەتگوزاریەک هەڵبژێرە...',
    bookDate: 'بەرواری خواستراو *',
    bookTime: 'کاتی خواستراو *',
    bookNotes: 'تێبینی (ئارەزوومەندانە)',
    bookSubmit: '← ناردنی شوێنپێچوون',
    // PDF modal
    pdfTitle: 'ئەژانسی AMKO — پرۆفایل',
  },
};

export const MARQUEE_ITEMS = {
  en: ['Creative Marketing','Event Management','Branding & Identity','Media Production','Digital Strategy','Visual Storytelling','Web & Digital','Content Creation','Event Planning'],
  ar: ['تسويق إبداعي','إدارة الفعاليات','البراندينغ والهوية','الإنتاج الإعلامي','الاستراتيجية الرقمية','الحكي البصري','الويب والرقمي','إنشاء المحتوى','تخطيط الفعاليات'],
  ku: ['مارکیتنگی داهێنان','بەڕێوەبردنی ئایین','براندینگ و ناسنامە','بەرهەمهێنانی میدیا','ستراتیژیی دیجیتاڵ','چیرۆکی بینایی','وێب و دیجیتاڵ','دروستکردنی ناوەڕۆک','پلاندانانی ئایین'],
};

export const DEFAULTS_AR = {
  hero: {
    tag: 'وكالة إبداعية — أربيل',
    line1: 'تسويق يحرك.',
    line2: 'فعاليات تلهم.',
    subtitle: 'من أربيل — نساعد الشركات تنمو من خلال البراندينغ، التسويق الرقمي، الإنتاج الإعلامي، والفعاليات اللي ما تُنسى.',
    bullets: [
      'حلول إبداعية وحديثة للأسواق المحلية والإقليمية',
      'تخطيط وتنفيذ فعاليات احترافية من البداية للنهاية',
      'إنتاج بصري عالي الجودة وقصص ذات تأثير حقيقي',
      'خدمات براندينغ وفعاليات متكاملة تحت سقف واحد',
    ],
    stats: [
      { num: '5+', label: 'سنوات' },
      { num: '100+', label: 'مشروع' },
      { num: '50+', label: 'عميل' },
    ],
  },
  about: {
    p1: 'وكالة AMKO تجمع الإبداع والتكنولوجيا وفهم السوق لتقديم تجارب براندينغ عصرية تربط الأعمال بجمهورها.',
    p2: 'نشتغل مع الشركات الناشئة، المنظمات، الشركات الكبيرة، المطاعم، الماركات التجارية، ورياديي الأعمال في أربيل ومنطقة كردستان.',
    vision: 'نكون من أكبر الوكالات الإبداعية في العراق والشرق الأوسط.',
    mission: 'تمكين الأعمال من خلال البراندينغ الاستراتيجي، الحكي الإبداعي، والتحول الرقمي.',
    stat: '5+',
    statLabel: 'سنة من صناعة الأثر في أربيل',
    values: ['✦ الإبداع', '⚡ الابتكار', '💎 الاحترافية', '🤝 الشفافية', '🎯 الجودة أولاً', '🚀 نجاح العميل'],
  },
  services: {
    items: [
      { icon: '🎨', title: 'البراندينغ والهوية', items: ['تصميم الشعار', 'دليل الهوية البصرية', 'تطوير الهوية المرئية', 'تصميم التغليف', 'تحديد موقع البراند'] },
      { icon: '📱', title: 'التسويق الرقمي', items: ['إدارة وسائل التواصل الاجتماعي', 'الإعلانات الرقمية', 'إنشاء المحتوى', 'إدارة الحملات', 'التسويق عبر المؤثرين'] },
      { icon: '💻', title: 'المواقع والحضور الرقمي', items: ['تصميم وتطوير المواقع', 'صفحات الهبوط', 'تصميم UI/UX', 'تحسين محركات البحث', 'الاستشارات الرقمية'] },
      { icon: '🎬', title: 'الإنتاج الإعلامي', items: ['التصوير الفوتوغرافي', 'التصوير المرئي', 'التصوير بالطائرة المسيّرة', 'الفيديوهات الترويجية', 'الإنتاج الوثائقي'] },
      { icon: '🎪', title: 'إدارة الفعاليات', items: ['الفعاليات والمؤتمرات', 'إطلاق المنتجات', 'المهرجانات والفعاليات العامة', 'الأعراس والفعاليات الخاصة', 'تصميم المسارح والأماكن'] },
      { icon: '🖼️', title: 'التصميم الجرافيكي', items: ['التصاميم الترويجية', 'البروشورات والمنشورات', 'الإعلانات الخارجية', 'هوية الفعاليات', 'البروفايلات المؤسسية'] },
    ],
  },
  process: {
    steps: [
      { n: '01', title: 'الحجز', desc: 'احجز استشارتك أونلاين' },
      { n: '02', title: 'الاستشارة', desc: 'نفهم أهدافك' },
      { n: '03', title: 'التخطيط', desc: 'نبني الاستراتيجية' },
      { n: '04', title: 'التنفيذ', desc: 'نسلّم بعناية' },
      { n: '05', title: 'النتائج', desc: 'نقيس ونكبر' },
    ],
  },
  clients: {
    list: ['Cultural & Social Center', 'Hawler Restaurant', 'Bashar E.S.Co', "Mar Qardakh Int'l School", 'Ankawa Opportunities', 'Merqamina Private School', 'Galaxy', 'Smashlab', 'Canto Del Mare', 'Dewilux', 'Casati Boya', 'Klimatherm', 'Twig'],
  },
  faqs: {
    items: [
      { q: 'شو الخدمات اللي تقدمها AMKO؟', a: 'البراندينغ، التسويق الرقمي، تطوير المواقع، الإنتاج الإعلامي، إدارة الفعاليات، والتصميم الجرافيكي.' },
      { q: 'كيف أحجز استشارة؟', a: 'اضغط "احجز استشارة" وعبي النموذج. نأكد خلال 24 ساعة.' },
      { q: 'كم يأخذ المشروع وقت؟', a: 'الشعار: 5–10 أيام. الهوية الكاملة: 2–4 أسابيع. الموقع: 4–8 أسابيع.' },
      { q: 'تشتغلون برا أربيل؟', a: 'نعم. نخدم عملاء في كردستان، العراق، وخارجياً للخدمات الرقمية.' },
    ],
  },
  contact: {
    phone: '+964 778 142 8130',
    email: 'Info@amkoiq.com',
    location: 'أربيل، إقليم كردستان، العراق',
    whatsapp: 'https://wa.me/9647781428130',
  },
};

export const DEFAULTS_KU = {
  hero: {
    tag: 'ئەژانسی داهێنانی — هەولێر',
    line1: 'مارکیتنگی دەجوڵێنێت.',
    line2: 'ئایینی ئیلهام دەبەخشێت.',
    subtitle: 'لە هەولێر — یارمەتیدەری بازرگانییەکان دەدەین تا گەشە بکەن لە ڕێگەی براندینگ، مارکیتنگی دیجیتاڵ، بەرهەمهێنانی میدیا، و ئایینی بیرنەچووەکان.',
    bullets: [
      'چارەسەری داهێنانی و مۆدێرن بۆ بازارەکانی ناوخۆ و ناوچەیی',
      'پلاندانان و جێبەجێکردنی ئایینی پیشەیی لە سەرەتا تا کۆتایی',
      'بەرهەمهێنانی بینایی بەرزکوالیتی و چیرۆکسازی کاریگەر',
      'خزمەتگوزارییەکانی براندینگ و ئایین لە خانەیەکدا',
    ],
    stats: [{ num: '5+', label: 'ساڵ' }, { num: '100+', label: 'پرۆژە' }, { num: '50+', label: 'کڕیار' }],
  },
  about: {
    p1: 'ئەژانسی AMKO داهێنان، تەکنەلۆژیا و تێگەیشتنی بازار یەکدەگرێتەوە بۆ دابینکردنی ئەزموونی براندینگی مۆدێرن کە بازرگانییەکان بە خەڵکی خۆیان دەبەستێتەوە.',
    p2: 'کار دەکەین لەگەڵ کۆمپانیا نوێکان، رێکخراوەکان، بازرگانییە گەورەکان، چێشتخانەکان، براندی بازرگانییەکان و کارئەندازان لە هەولێر و هەرێمی کوردستان.',
    vision: 'یەکێک لە گەورەترین ئەژانسە داهێنانەکان لە عێراق و ڕۆژهەڵاتی ناوین دەبین.',
    mission: 'توانادار کردنی بازرگانییەکان لە ڕێگەی براندینگی ستراتیژیی، چیرۆکسازی داهێنان و گۆڕانکاری دیجیتاڵ.',
    stat: '5+',
    statLabel: 'ساڵ کاریگەری لە هەولێر',
    values: ['✦ داهێنان', '⚡ نوێکاری', '💎 پیشەیی بوون', '🤝 ڕاستگۆیی', '🎯 کوالیتی پێش هەموو شتێک', '🚀 سەرکەوتنی کڕیار'],
  },
  services: {
    items: [
      { icon: '🎨', title: 'براندینگ و ناسنامە', items: ['دیزاینی لۆگۆ', 'ڕێنمایی ناسنامەی بینایی', 'پەرەپێدانی ناسنامەی دیداری', 'دیزاینی پاکێج', 'دانانی براند'] },
      { icon: '📱', title: 'مارکیتنگی دیجیتاڵ', items: ['بەڕێوەبردنی میدیای کۆمەڵایەتی', 'ڕیکلامی دیجیتاڵ', 'دروستکردنی ناوەڕۆک', 'بەڕێوەبردنی کامپەین', 'مارکیتنگ لە ڕێگەی مؤثران'] },
      { icon: '💻', title: 'وێب و دیجیتاڵ', items: ['دیزاین و پەرەپێدانی ماڵپەڕ', 'پەڕەی دابەزین', 'دیزاینی UI/UX', 'باشترکردنی دەستپێکردن', 'ئەڕاستەکاری دیجیتاڵ'] },
      { icon: '🎬', title: 'بەرهەمهێنانی میدیا', items: ['وێنەگرتن', 'ڤیدیۆگرتن', 'فلمگرتن بە دڕۆن', 'ڤیدیۆی ڕیکلامی', 'بەرهەمهێنانی بەڵگەنامە'] },
      { icon: '🎪', title: 'بەڕێوەبردنی ئایین', items: ['ئایین و کۆنفراسی کۆرپۆرەیت', 'ئەڵانی بەرهەم', 'فێستیڤاڵ و ئایینی گشتی', 'جژن و ئایینی تایبەت', 'دیزاینی سەھنە و شوێن'] },
      { icon: '🖼️', title: 'دیزاینی گرافیک', items: ['دیزاینی ڕیکلامی', 'بروشور و فلایەر', 'بانەریکلام و ڕیکلامی دەرەوە', 'براندینگی ئایین', 'پرۆفایلی کۆمپانیا'] },
    ],
  },
  process: {
    steps: [
      { n: '01', title: 'شوێنپێچوون', desc: 'شوێنپێچوونەکەت ئۆنلاین تۆمار بکە' },
      { n: '02', title: 'ئەڕاستەکاری', desc: 'ئامانجەکانت تێدەگەین' },
      { n: '03', title: 'پلاندانان', desc: 'ستراتیژیەکە دەبەستین' },
      { n: '04', title: 'جێبەجێکردن', desc: 'بە ئەرەزووی دەگەیەنین' },
      { n: '05', title: 'ئەنجامەکان', desc: 'پێوەرەکان دەمەسینین و گەشە دەکەین' },
    ],
  },
  clients: {
    list: ['Cultural & Social Center', 'Hawler Restaurant', 'Bashar E.S.Co', "Mar Qardakh Int'l School", 'Ankawa Opportunities', 'Merqamina Private School', 'Galaxy', 'Smashlab', 'Canto Del Mare', 'Dewilux', 'Casati Boya', 'Klimatherm', 'Twig'],
  },
  faqs: {
    items: [
      { q: 'چی خزمەتگوزارییەکی AMKO دەدات؟', a: 'براندینگ، مارکیتنگی دیجیتاڵ، پەرەپێدانی ماڵپەڕ، بەرهەمهێنانی میدیا، بەڕێوەبردنی ئایین و دیزاینی گرافیک.' },
      { q: 'چۆن شوێنپێچوون تۆمار بکەم؟', a: '"شوێنپێچوون" دابەزێنە و فۆرمەکە پڕ بکەوە. لە ماوەی ٢٤ کاتژمێردا پشتدەڵنیا دەبین.' },
      { q: 'پرۆژە چەند کات دەخایەنێت؟', a: 'لۆگۆ: ٥–١٠ ڕۆژ. ناسنامەی تەواو: ٢–٤ هەفتە. ماڵپەڕ: ٤–٨ هەفتە.' },
      { q: 'دەرەوەی هەولێر کار دەکەن؟', a: 'بەڵێ. کڕیار خزمەت دەکەین لە کوردستان، عێراق، و نێودەوڵەتی بۆ خزمەتگوزارییە دیجیتاڵەکان.' },
    ],
  },
  contact: {
    phone: '+964 778 142 8130',
    email: 'Info@amkoiq.com',
    location: 'هەولێر، هەرێمی کوردستان، عێراق',
    whatsapp: 'https://wa.me/9647781428130',
  },
};
